module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text",
    attrs: {
      "id": "TEXT-SWF"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mask_visible_),
      expression: "mask_visible_"
    }],
    staticClass: "mask_"
  }), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, _vm._l((_vm.tabs_data), function(item, index) {
    return _c('div', {
      class: {
        'active': item.active
      },
      on: {
        "click": function($event) {
          return _vm.handleTabsChange(index, _vm.tabs_data)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "con"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 0),
      expression: "type == 0"
    }]
  }, [_c('div', {
    staticClass: "toolbar",
    staticStyle: {
      "height": "50px"
    }
  }, [_c('div', {
    staticClass: "font-family"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('el-select', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "placeholder": "字体"
    },
    on: {
      "change": _vm.handleSubtitlesFontFamilyChange
    },
    model: {
      value: (_vm.form_subtitles.font_family),
      callback: function($$v) {
        _vm.$set(_vm.form_subtitles, "font_family", $$v)
      },
      expression: "form_subtitles.font_family"
    }
  }, _vm._l((_vm.form_subtitles.font_family_options), function(item) {
    return _c('el-option', {
      key: item.value,
      style: ('font-size: 12px; font-family:' + item.value),
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "font-size",
    staticStyle: {
      "width": "62px",
      "position": "relative",
      "left": "90px",
      "top": "-26px",
      "padding-right": "0px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "字号"
    },
    on: {
      "change": _vm.handleSubtitlesFontFizeChange
    },
    model: {
      value: (_vm.form_subtitles.font_size),
      callback: function($$v) {
        _vm.$set(_vm.form_subtitles, "font_size", $$v)
      },
      expression: "form_subtitles.font_size"
    }
  }, _vm._l((_vm.form_subtitles.font_size_options), function(item) {
    return _c('el-option', {
      key: item.value,
      staticStyle: {
        "font-size": "12px"
      },
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-color-picker', {
    staticStyle: {
      "margin-left": "150px",
      "width": "20px",
      "height": "20px",
      "top": "-57px"
    },
    attrs: {
      "size": "medium"
    },
    on: {
      "change": _vm.handleSubtitlesColorChange
    },
    model: {
      value: (_vm.form_subtitles.color),
      callback: function($$v) {
        _vm.$set(_vm.form_subtitles, "color", $$v)
      },
      expression: "form_subtitles.color"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "align"
  }, _vm._l((_vm.halign_data), function(item, index) {
    return _c('div', {
      class: {
        'active': item.active
      },
      on: {
        "click": function($event) {
          return _vm.handleSubtitlesHalignChange(index, _vm.halign_data)
        }
      }
    }, [_c('i', {
      class: item.class
    })])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "subtitles"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("字幕文字输入框"), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tip_visible),
      expression: "tip_visible"
    }]
  }, [_vm._v("最多输入 "), _c('strong', [_vm._v("512")]), _vm._v(" 个字符")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('el-input', {
    staticClass: "subtitles_con",
    attrs: {
      "type": "textarea",
      "resize": "none"
    },
    on: {
      "input": _vm.handleSubtitlesChange
    },
    model: {
      value: (_vm.form_subtitles.content),
      callback: function($$v) {
        _vm.$set(_vm.form_subtitles, "content", $$v)
      },
      expression: "form_subtitles.content"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "subtitles-list-wrapper"
  }, [_c('div', {
    staticClass: "subtitles-list-header"
  }, [_c('span', [_vm._v("当前页字幕列表")]), _vm._v(" "), _c('el-checkbox', {
    on: {
      "change": _vm.handleSelectAll
    },
    model: {
      value: (_vm.selectAll),
      callback: function($$v) {
        _vm.selectAll = $$v
      },
      expression: "selectAll"
    }
  }, [_vm._v("全选")])], 1), _vm._v(" "), _c('div', {
    staticClass: "subtitles-list-content"
  }, [_vm._l((_vm.currentPageSubtitles), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "subtitle-item",
      class: {
        'active': _vm.currentStepIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.handleStepClick(index)
        }
      }
    }, [_c('div', {
      staticClass: "subtitle-checkbox"
    }, [_c('el-checkbox', {
      on: {
        "change": function($event) {
          return _vm.handleItemSelect(index)
        }
      },
      model: {
        value: (item.selected),
        callback: function($$v) {
          _vm.$set(item, "selected", $$v)
        },
        expression: "item.selected"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "subtitle-input"
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "rows": 2,
        "resize": "none",
        "placeholder": "请输入字幕文字..."
      },
      on: {
        "input": function($event) {
          return _vm.handleSubtitleTextChange(index)
        },
        "focus": function($event) {
          return _vm.handleStepClick(index)
        }
      },
      model: {
        value: (item.text),
        callback: function($$v) {
          _vm.$set(item, "text", $$v)
        },
        expression: "item.text"
      }
    })], 1)])
  }), _vm._v(" "), (_vm.currentPageSubtitles.length === 0) ? _c('div', {
    staticClass: "empty-state"
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _vm._v(" "), _c('p', [_vm._v("当前页暂无字幕")])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tts-params-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tts-params-content"
  }, [_c('div', {
    staticClass: "param-row"
  }, [_c('div', {
    staticClass: "subtitle-voice"
  }, [_c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "320",
      "trigger": "click"
    },
    model: {
      value: (_vm.voicePopoverVisible),
      callback: function($$v) {
        _vm.voicePopoverVisible = $$v
      },
      expression: "voicePopoverVisible"
    }
  }, [_c('div', {
    staticClass: "voice-selector-panel"
  }, [_c('div', {
    staticClass: "voice-tabs"
  }, [(_vm.team_id) ? _c('div', {
    class: ['voice-tab', {
      active: _vm.voiceTabActive === 'team'
    }],
    on: {
      "click": function($event) {
        _vm.voiceTabActive = 'team'
      }
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.team_name || '团队音色') + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: ['voice-tab', {
      active: _vm.voiceTabActive === 'public'
    }],
    on: {
      "click": function($event) {
        _vm.voiceTabActive = 'public'
      }
    }
  }, [_vm._v("\n                          公共音色\n                        ")]), _vm._v(" "), _c('div', {
    class: ['voice-tab', {
      active: _vm.voiceTabActive === 'my'
    }],
    on: {
      "click": function($event) {
        _vm.voiceTabActive = 'my'
      }
    }
  }, [_vm._v("\n                          我的音色\n                        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.voiceTabActive === 'team'),
      expression: "voiceTabActive === 'team'"
    }],
    staticClass: "voice-list"
  }, [_c('div', {
    staticClass: "voice-list-header"
  }, [_c('i', {
    staticClass: "el-icon-refresh",
    class: {
      rotating: _vm.team_voice_loading
    },
    attrs: {
      "title": "刷新"
    },
    on: {
      "click": _vm.loadTeamVoiceList
    }
  })]), _vm._v(" "), _vm._l((_vm.team_voice_list), function(voice) {
    return _c('div', {
      key: voice.voiceId,
      class: ['voice-item', {
        selected: _vm.tts_global_config.voice === voice.voiceId
      }],
      on: {
        "click": function($event) {
          return _vm.selectVoice(voice.voiceId)
        }
      }
    }, [_c('div', {
      staticClass: "voice-info"
    }, [_c('span', {
      staticClass: "voice-name"
    }, [_vm._v(_vm._s(voice.voiceName))])]), _vm._v(" "), _c('div', {
      staticClass: "voice-actions"
    }, [(voice.expirationTime) ? _c('span', {
      staticClass: "voice-expiration"
    }, [_vm._v("\n                              过期日期: " + _vm._s(_vm.formatExpirationTime(voice.expirationTime)) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.tts_global_config.voice === voice.voiceId) ? _c('i', {
      staticClass: "el-icon-check"
    }) : _vm._e(), _vm._v(" "), (voice.canDeleted) ? _c('i', {
      staticClass: "el-icon-delete",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteTeamVoice(voice.voiceId)
        }
      }
    }) : _vm._e()])])
  }), _vm._v(" "), (_vm.team_voice_list.length === 0 && !_vm.team_voice_loading) ? _c('div', {
    staticClass: "voice-empty"
  }, [_c('i', {
    staticClass: "el-icon-microphone"
  }), _vm._v(" "), _c('p', [_vm._v("暂无团队音色")])]) : _vm._e(), _vm._v(" "), (_vm.team_voice_loading) ? _c('div', {
    staticClass: "voice-loading"
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" 加载中...\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "voice-add-btn",
    on: {
      "click": _vm.openTeamVoiceManageDialog
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" 添加音色\n                        ")])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.voiceTabActive === 'public'),
      expression: "voiceTabActive === 'public'"
    }],
    staticClass: "voice-list"
  }, [_vm._l((_vm.voice_list), function(voice) {
    return _c('div', {
      key: voice.voiceId,
      class: ['voice-item', {
        selected: _vm.tts_global_config.voice === voice.voiceId
      }],
      on: {
        "click": function($event) {
          return _vm.selectVoice(voice.voiceId)
        }
      }
    }, [_c('span', {
      staticClass: "voice-name"
    }, [_vm._v(_vm._s(voice.voiceName))]), _vm._v(" "), (_vm.tts_global_config.voice === voice.voiceId) ? _c('i', {
      staticClass: "el-icon-check"
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.voice_list_loading) ? _c('div', {
    staticClass: "voice-loading"
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" 加载中...\n                        ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.voiceTabActive === 'my'),
      expression: "voiceTabActive === 'my'"
    }],
    staticClass: "voice-list"
  }, [_c('div', {
    staticClass: "voice-list-header"
  }, [_c('i', {
    staticClass: "el-icon-refresh",
    class: {
      rotating: _vm.my_voice_loading
    },
    attrs: {
      "title": "刷新"
    },
    on: {
      "click": _vm.loadMyVoiceList
    }
  })]), _vm._v(" "), _vm._l((_vm.my_voice_list), function(voice) {
    return _c('div', {
      key: voice.voiceId,
      class: ['voice-item', {
        selected: _vm.tts_global_config.voice === voice.voiceId
      }],
      on: {
        "click": function($event) {
          return _vm.selectVoice(voice.voiceId)
        }
      }
    }, [_c('div', {
      staticClass: "voice-info"
    }, [_c('span', {
      staticClass: "voice-name"
    }, [_vm._v(_vm._s(voice.voiceName))])]), _vm._v(" "), _c('div', {
      staticClass: "voice-actions"
    }, [(voice.expirationTime) ? _c('span', {
      staticClass: "voice-expiration"
    }, [_vm._v("\n                              过期日期: " + _vm._s(_vm.formatExpirationTime(voice.expirationTime)) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.tts_global_config.voice === voice.voiceId) ? _c('i', {
      staticClass: "el-icon-check"
    }) : _vm._e(), _vm._v(" "), (voice.canDeleted) ? _c('i', {
      staticClass: "el-icon-delete",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteMyVoice(voice.voiceId)
        }
      }
    }) : _vm._e()])])
  }), _vm._v(" "), (_vm.my_voice_list.length === 0 && !_vm.my_voice_loading) ? _c('div', {
    staticClass: "voice-empty"
  }, [_c('i', {
    staticClass: "el-icon-microphone"
  }), _vm._v(" "), _c('p', [_vm._v("暂无自定义音色")])]) : _vm._e(), _vm._v(" "), (_vm.my_voice_loading) ? _c('div', {
    staticClass: "voice-loading"
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" 加载中...\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "voice-add-btn",
    on: {
      "click": _vm.openMyVoiceManageDialog
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" 添加音色\n                        ")])], 2)]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "slot": "reference",
      "size": "small"
    },
    slot: "reference"
  }, [_c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.getSelectedVoiceName()))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down",
    staticStyle: {
      "float": "right",
      "margin-top": "4px"
    }
  })])], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "情感",
      "disabled": !_vm.current_voice_emotions.length
    },
    on: {
      "change": _vm.handleEmotionChange
    },
    model: {
      value: (_vm.tts_global_config.emotion),
      callback: function($$v) {
        _vm.$set(_vm.tts_global_config, "emotion", $$v)
      },
      expression: "tts_global_config.emotion"
    }
  }, _vm._l((_vm.current_voice_emotions), function(emotion) {
    return _c('el-option', {
      key: emotion.value,
      attrs: {
        "label": emotion.label,
        "value": emotion.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "param-item"
  }, [_c('label', [_vm._v("语速：")]), _vm._v(" "), _c('el-slider', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "min": 0.5,
      "max": 2.0,
      "step": 0.1,
      "show-input-controls": false
    },
    model: {
      value: (_vm.tts_global_config.speed),
      callback: function($$v) {
        _vm.$set(_vm.tts_global_config, "speed", $$v)
      },
      expression: "tts_global_config.speed"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "param-item"
  }, [_c('label', [_vm._v("音量：")]), _vm._v(" "), _c('el-slider', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "min": 0,
      "max": 100,
      "step": 1,
      "show-input-controls": false
    },
    model: {
      value: (_vm.tts_global_config.volume),
      callback: function($$v) {
        _vm.$set(_vm.tts_global_config, "volume", $$v)
      },
      expression: "tts_global_config.volume"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "param-item"
  }, [_c('label', [_vm._v("音调：")]), _vm._v(" "), _c('el-slider', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "min": 0.5,
      "max": 2.0,
      "step": 0.1,
      "show-input-controls": false
    },
    model: {
      value: (_vm.tts_global_config.pitch),
      callback: function($$v) {
        _vm.$set(_vm.tts_global_config, "pitch", $$v)
      },
      expression: "tts_global_config.pitch"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "lip-sync-wrapper"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "lip-sync-content"
  }, [_c('div', {
    staticClass: "param-row"
  }, [_c('div', {
    staticClass: "lip-sync-character"
  }, [_c('label', [_vm._v("形象：")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "选择形象",
      "loading": _vm.bundle_list_loading
    },
    on: {
      "change": _vm.handleCharacterChange
    },
    model: {
      value: (_vm.lip_sync_config.bundleAlias),
      callback: function($$v) {
        _vm.$set(_vm.lip_sync_config, "bundleAlias", $$v)
      },
      expression: "lip_sync_config.bundleAlias"
    }
  }, _vm._l((_vm.bundle_list), function(character) {
    return _c('el-option', {
      key: character.alias,
      attrs: {
        "label": _vm.getBundleName(character.id),
        "value": character.alias
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      }
    }, [(_vm.getBundleThumb(character.id)) ? _c('img', {
      staticStyle: {
        "display": "block",
        "width": "26px",
        "height": "26px",
        "border": "1px solid #ccc",
        "padding": "2px",
        "margin-right": "8px",
        "background": "#fff",
        "object-fit": "cover",
        "object-position": "center top"
      },
      attrs: {
        "src": _vm.getBundleThumb(character.id)
      }
    }) : _c('span', {
      staticStyle: {
        "width": "26px",
        "height": "26px",
        "margin-right": "8px",
        "display": "flex",
        "align-items": "center",
        "justify-content": "center",
        "font-size": "16px"
      }
    }, [_vm._v("🎭")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getBundleName(character.id)))])])])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "lip-sync-emotion"
  }, [_c('label', [_vm._v("表情：")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "选择表情"
    },
    on: {
      "change": _vm.handleLipSyncEmotionChange
    },
    model: {
      value: (_vm.lip_sync_config.emotion),
      callback: function($$v) {
        _vm.$set(_vm.lip_sync_config, "emotion", $$v)
      },
      expression: "lip_sync_config.emotion"
    }
  }, _vm._l((_vm.lip_sync_emotions), function(emotion) {
    return _c('el-option', {
      key: emotion.value,
      attrs: {
        "label": emotion.label,
        "value": emotion.value
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "24px",
        "height": "24px",
        "margin-right": "8px"
      },
      attrs: {
        "src": emotion.icon
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(emotion.label))])])])
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "param-row"
  }, [_c('div', {
    staticClass: "param-item"
  }, [_c('label', [_vm._v("表情等级：")]), _vm._v(" "), _c('el-slider', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "min": 0,
      "max": 7,
      "step": 1,
      "show-input-controls": false,
      "show-stops": ""
    },
    on: {
      "change": _vm.handleEmotionLevelChange
    },
    model: {
      value: (_vm.lip_sync_config.emotionLevel),
      callback: function($$v) {
        _vm.$set(_vm.lip_sync_config, "emotionLevel", $$v)
      },
      expression: "lip_sync_config.emotionLevel"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "param-value"
  }, [_vm._v(_vm._s(_vm.lip_sync_config.emotionLevel))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "lip-sync-actions"
  }, [_c('el-checkbox', {
    staticClass: "auto-generate-checkbox",
    model: {
      value: (_vm.lip_sync_config.autoGenerate),
      callback: function($$v) {
        _vm.$set(_vm.lip_sync_config, "autoGenerate", $$v)
      },
      expression: "lip_sync_config.autoGenerate"
    }
  }, [_vm._v("\n              自动生成\n            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-video-camera",
      "loading": _vm.lip_sync_generating,
      "disabled": _vm.generatedSentences.length == 0
    },
    on: {
      "click": _vm.handleGenerateLipSync
    }
  }, [_vm._v("\n              生成口型\n            ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tts-actions-wrapper"
  }, [(_vm.tts_status_message) ? _c('div', {
    staticClass: "tts-status"
  }, [_c('i', {
    class: _vm.tts_status_icon
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tts_status_message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tts-buttons"
  }, [_c('el-tooltip', {
    attrs: {
      "content": _vm.tts_generating ? '生成中...' : '生成语音',
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-microphone",
      "loading": _vm.tts_generating,
      "disabled": !_vm.form_subtitles.content
    },
    on: {
      "click": _vm.handleGenerateTTS
    }
  })], 1), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "试听",
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-video-play",
      "disabled": !_vm.hasGeneratedAudio
    },
    on: {
      "click": _vm.handlePreviewTTS
    }
  })], 1), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "disabled": !_vm.hasGeneratedAudio
    },
    on: {
      "command": _vm.handleAddToTimeline
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "添加到时间轴",
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-download",
      "disabled": !_vm.hasGeneratedAudio
    }
  })], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "voice"
    }
  }, [_vm._v("配音")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "sound_effect"
    }
  }, [_vm._v("旁白")])], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 1),
      expression: "type == 1"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mask_visible),
      expression: "mask_visible"
    }],
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "toolbar"
  }, [_c('div', {
    staticClass: "font-family"
  }, [_c('div', {
    staticClass: "inner",
    staticStyle: {
      "width": "60px",
      "height": "25px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90px"
    },
    attrs: {
      "size": "mini",
      "placeholder": "字体",
      "disabled": _vm.mask_visible
    },
    on: {
      "change": _vm.handleBubbleFontFamilyChange
    },
    model: {
      value: (_vm.form_bubble.font_family),
      callback: function($$v) {
        _vm.$set(_vm.form_bubble, "font_family", $$v)
      },
      expression: "form_bubble.font_family"
    }
  }, _vm._l((_vm.form_bubble.font_family_options), function(item) {
    return _c('el-option', {
      key: item.value,
      style: ('font-size: 12px; font-family:' + item.value),
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('el-color-picker', {
    staticStyle: {
      "margin-left": "110px",
      "width": "20px",
      "height": "20px",
      "top": "-30px"
    },
    attrs: {
      "size": "medium"
    },
    on: {
      "change": _vm.handleBubbleColorChange
    },
    model: {
      value: (_vm.form_bubble.color),
      callback: function($$v) {
        _vm.$set(_vm.form_bubble, "color", $$v)
      },
      expression: "form_bubble.color"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 1),
      expression: "type == 1"
    }],
    staticClass: "subtitles"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("气泡文字输入框")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "resize": "none",
      "disabled": _vm.mask_visible
    },
    on: {
      "input": _vm.handleBubbleChange
    },
    model: {
      value: (_vm.form_bubble.content),
      callback: function($$v) {
        _vm.$set(_vm.form_bubble, "content", $$v)
      },
      expression: "form_bubble.content"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 1),
      expression: "type == 1"
    }],
    staticClass: "bubble"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("气泡样式")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "con"
  }, _vm._l((_vm.bubble_data), function(item, index) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.handleBubbleAdd(item.ori_data_id)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.thumb
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.more),
      expression: "more"
    }],
    staticClass: "more",
    on: {
      "click": _vm.handleMore
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._v("加载更多")])])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "音色管理",
      "visible": _vm.voiceManageDialogVisible,
      "width": "600px",
      "close-on-click-modal": false,
      "modal-append-to-body": false,
      "append-to-body": true,
      "custom-class": "voice-manage-dialog"
    },
    on: {
      "update:visible": function($event) {
        _vm.voiceManageDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "voice-manage-content"
  }, [_c('el-form', {
    attrs: {
      "model": _vm.voiceForm,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "创建方式"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.voiceCreateType),
      callback: function($$v) {
        _vm.voiceCreateType = $$v
      },
      expression: "voiceCreateType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "clone"
    }
  }, [_vm._v("声音复刻")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "design"
    }
  }, [_vm._v("声音设计")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "音色名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入音色名称",
      "maxlength": "20"
    },
    model: {
      value: (_vm.newVoiceName),
      callback: function($$v) {
        _vm.newVoiceName = $$v
      },
      expression: "newVoiceName"
    }
  })], 1), _vm._v(" "), (_vm.voiceCreateType === 'clone') ? [_c('el-form-item', {
    attrs: {
      "label": "音频文件"
    }
  }, [_c('el-upload', {
    staticClass: "voice-upload",
    attrs: {
      "action": "#",
      "auto-upload": false,
      "on-change": _vm.handleVoiceFileChange,
      "file-list": _vm.voiceFileList,
      "limit": 1,
      "accept": "audio/*",
      "drag": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将音频文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("支持mp3、wav等音频格式，建议时长10-30秒")])])], 1)] : [_c('el-form-item', {
    attrs: {
      "label": "声音描述"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "描述期望的音色特征，如：沉稳的中年男性播音员，音色低沉浑厚，富有磁性，语速平稳，吐字清晰",
      "maxlength": "200",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.voicePrompt),
      callback: function($$v) {
        _vm.voicePrompt = $$v
      },
      expression: "voicePrompt"
    }
  })], 1)]], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.voiceManageDialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.voiceGenerating,
      "disabled": !_vm.canGenerateVoice
    },
    on: {
      "click": _vm.handleGenerateVoice
    }
  }, [_vm._v("\n        生成音色\n      ")])], 1)]), _vm._v(" "), _c('psocket', {
    attrs: {
      "attributes": _vm.attributes,
      "flashvars": _vm.flashvars
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tts-params-header"
  }, [_c('i', {
    staticClass: "el-icon-setting"
  }), _vm._v(" "), _c('span', [_vm._v("语音参数设置")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lip-sync-header"
  }, [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" "), _c('span', [_vm._v("口型匹配")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d7b283d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Text.vue
// module id = 400
// module chunks = 0